export const supplant = (source: string | undefined, holder: Record<string, string>): string | undefined => {
  if (source == null) return source;

  const replacer = (substring: string, args: string) => holder[args] || substring;

  return source.replace(/{([^{}]*)}/g, replacer);
};
